import React, { Suspense } from 'react'
import style from './StyledSuspense.less'
import PropTypes from 'prop-types'

 const SpinnerSuspense = ({ children }) => (
  <Suspense fallback={<span className={style.spinner} />}>
    {children}
  </Suspense>
)

SpinnerSuspense.propTypes = {
  children: PropTypes.node.isRequired,
}

const FormSuspense = ({ children }) => (
  <Suspense fallback={<div className={style.form} > </div>}>
    {children}
  </Suspense>
)

FormSuspense.propTypes = {
  children: PropTypes.node.isRequired,
}

const EmptySuspense = ({ children }) => (
  <Suspense fallback={<div> </div>}>
    {children}
  </Suspense>
)

const TabSuspense = ({ children }) => (
  <Suspense fallback={<div className={style.tab} > </div>}>
    {children}
  </Suspense>
)


export {
  SpinnerSuspense,
  FormSuspense,
  EmptySuspense,
  TabSuspense,
}
